export default __webpack_public_path__ + "static/media/Path3362.7595da6f.svg";